<!--  -->
<template>
  <van-popup
    v-model="examSeasonCourseVisible"
    class="statusPopup"
    :duration="0"
    :close-on-click-overlay="false"
  >
    <div class="examSeason">
      <div class="content">
        <div class="exam">
          <div
            :class="{ active: examNum.name === item.name }"
            v-for="(item, i) in examList"
            :key="i"
            @click="choose(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="btn" :class="{active:examNum.name}" @click="submit"></div>
    </div>
  </van-popup>
</template>

<script>
import {reqNewUserRecord} from '@/api/login';
import {setBaseUrl} from '@/utils/tools';

export default {
  components: {},
  props: {
    examSeasonCourseVisible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      examNum: {},
      examList: [
        {
          name: '26考研',
          key: 1117,
        },
        {
          name: '27考研',
          key: 1331,
        },
        {
          name: '其他',
          key: 0,
        },
      ],
      point: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    choose(item) {
      this.examNum = item;
    },
    async submit() {
      if (!this.examNum.name) {
        this.$toast('请选择考试信息');
        return;
      }
      if (this.examNum.key === 0) {
        this.close();
        return;
      }
      if (this.point) return;
      this.point = true;
      const {code, msg} = await reqNewUserRecord({
        company: 1,
        labelTreeIdList: [this.examNum.key],
        userCenter: false,
      });
      if (code === 0) {
        this.close();
      } else {
        this.$toast(msg);
      }
      this.point = false
    },
    close() {
      this.$emit('closeAfter', true);
    },
  },
  created() {
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.statusPopup {
  width: 621px;
  height: 575px;
  background: url("https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullNew/course_examSeason_bg.png");
  background-size: 100% 100%;
}

.examSeason {

}

.content {
  box-sizing: border-box;
  padding: 0 24px;
  margin-top: 327px;

  > p {
    padding: 32px 0;
    color: #733d08;
    font-weight: 500;
    font-size: 28px;
    line-height: 40px;
    text-align: center;
  }

  .exam {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: space-between;

    > div {
      width: 181px;
      height: 60px;
      background: #FFFFFF;
      border-radius: 30px;
      border: 2px solid #DADAD7;
      line-height: 56px;
      text-align: center;
      color: #333;
      font-weight: 400;
      font-size: 28px;
    }

    > div.active {
      background: #ff7f41;
      border: none;
      line-height: 60px;
      b {
        color: #ffff;
      }
    }
  }
}
.btn {
  display: block;
  width: 394px;
  height: 110px;
  opacity: 0.5;
  background: url("https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullNew/course_btn.png");
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 42px;
}

.btn.active {
  opacity: 1;
}

.btn3.active {
  opacity: 1;
}
</style>
